import type { components } from "@dolfin/api-public";

type MatchLineView = components["schemas"]["MatchLineView"];

// The backend marks engine allocations autoAccepted and settles their variance with a null actor; nothing is inferred here.

/** Every allocation on this line was committed by the matching engine — no human picked any of them. */
export function isAutoMatched(line: MatchLineView): boolean {
  return line.allocations.length > 0 && line.allocations.every((a) => a.autoAccepted);
}

/** This line's variance was settled by the engine rather than a person (null actor on the resolution). */
export function isAutoResolved(line: MatchLineView): boolean {
  return line.resolution != null && line.resolution.resolvedBy == null;
}

/** The WEAKEST dimension, as the backend decides a line. Null when nothing carries a score (exact-SKU or manual). */
export function autoConfidence(line: MatchLineView): number | null {
  const scores = line.allocations
    .map((a) => a.matchConfidence)
    .filter((c): c is number => c != null)
    .map(Number);
  return scores.length > 0 ? Math.min(...scores) : null;
}
